import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import Subscribers from './Subscribers';
import columnTypes from '../../components/cms/grid/columnTypes';
import gc from '../../components/cms/gridComponents';
import ModelService from '../../services/subscriber.service';

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>)
  },
  {
    name: 'name',
    title: t('URL'),
    value: ({ item }) => (<a href={ModelService.getUrl(item)} target="_blank">{`${item.name}.avanga.org`}</a>)
  },
  {
    name: 'title',
    title: t('Company title'),
    value: ({ item }) => (<a href={ModelService.getUrl(item)} target="_blank">{item.title}</a>)
  },
  {
    name: 'email',
    title: t('E-mail'),
  },
  {
    name: 'created_at',
    title: t('Created at'),
    value: gc.dateDataCell({ attr: 'created_at' }),
    filter: false,
  },
  {
    name: 'last_activity_at',
    title: t('Last activity'),
    value: gc.dateDataCell({ attr: 'last_activity_at' }),
    filter: false,
  },
  {
    name: 'status',
    title: t('Status'),
    value: ({ item: { status } }) => (
      <Badge color={ModelService.getColorByStatus(status)}>
        {ModelService.getStatusTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  },
  // {
  //   name: 'payment_status',
  //   title: t('Payment status'),
  //   value: ({ item: { payment_status: status } }) => (
  //     <Badge color={ModelService.getColorByPaymentStatus(status)}>
  //       {ModelService.getPaymentStatusTitle(status, t)}
  //     </Badge>
  //   ),
  //   filter: gc.selectFilter(ModelService.getPaymentStatusOptions(t)),
  // },
  {
    type: columnTypes.BUTTONS,
    showDeleteButton: false
  },
];

const enhance = compose(
  translate('core'),
  defaultProps({
    getColumns,
  }),
);

export default hoistStatics(enhance)(Subscribers);



// WEBPACK FOOTER //
// ./src/views/subscribers/index.js